const getCourseProfileAttributes = `
    query getCourseProfileAttributes($courseTag:String!, $variant:String)
    {
        courseProfileAttributes(courseTag:$courseTag, variant:$variant) {
            fieldName
            type
            style
            value
            values
            required
            group
            label
            attribute
            hint
            additionalText
            position
            dataBinder
            formLock
            formShow
                        validators {
                            name
                            value
                            failMessage
                            validator {
                                id
                                type
                                name
                                regularExpression
                                requiresValue
                            }
                        }
        }
    }
`;

export default getCourseProfileAttributes;
